"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const MapMini = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 24,
  height: 24,
  viewBox: "3 3 18 18"
}, props), _react.default.createElement("g", {
  className: "fill"
}, _react.default.createElement("path", {
  d: "M17.436 5H6.564c-.964 0-1.477.1-2.012.385-.5.268-.9.666-1.167 1.167C3.1 7.087 3 7.6 3 8.564v6.872c0 .964.1 1.477.385 2.012.268.5.666.9 1.167 1.167C5.087 18.9 5.6 19 6.564 19h10.872c.964 0 1.477-.1 2.012-.385.5-.268.9-.666 1.167-1.167.286-.535.385-1.048.385-2.012V8.564c0-.964-.1-1.477-.385-2.012a2.817 2.817 0 00-1.167-1.167C18.913 5.1 18.4 5 17.436 5zm.17 2.001l.278.008.114.008.186.023c.135.024.228.059.321.109a.818.818 0 01.346.346c.05.093.085.186.109.321l.023.186.008.114.008.278v7.212l-.008.278-.008.114-.023.186a1.003 1.003 0 01-.109.321.818.818 0 01-.346.346c-.093.05-.186.085-.321.109l-.186.023a3.723 3.723 0 01-.114.008l-.278.008H6.394l-.278-.008a3.723 3.723 0 01-.114-.008l-.186-.023a1.003 1.003 0 01-.321-.109.818.818 0 01-.346-.346c-.078-.145-.12-.289-.138-.594L5 15.606V8.394l.008-.278.008-.114.023-.186c.024-.135.059-.228.109-.321a.818.818 0 01.346-.346c.145-.078.289-.12.594-.138L6.394 7h11.212z"
}), _react.default.createElement("path", {
  d: "M11.282 9h4.436c.446 0 .607.046.77.134.163.087.291.215.378.378.088.163.134.324.134.77v2.436c0 .446-.046.607-.134.77a.909.909 0 01-.378.378c-.163.088-.324.134-.77.134h-4.436c-.446 0-.607-.046-.77-.134a.909.909 0 01-.378-.378c-.088-.163-.134-.324-.134-.77v-2.436c0-.446.046-.607.134-.77a.909.909 0 01.378-.378c.163-.088.324-.134.77-.134z"
})));

var _default = MapMini;
exports.default = _default;